export enum AUTH_PROVIDER_TYPE {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
}
